import { Navbar, Nav, Container } from "react-bootstrap";

const navLinks = [
  { label: "About", href: "/#about" },
  { label: "Features", href: "/#features" },
  { label: "Pricing", href: "/#pricing" },
  { label: "Contact", href: "/#contact" },
];

const Header = function () {
  return (
    <header
      style={{
        position: "sticky",
        top: "0px",
        zIndex: 1020,
        backgroundColor: "#0a5a6a",
      }}
    >
      <Navbar
        expand="md"
        collapseOnSelect
        variant="dark"
        style={{ backgroundColor: "#0a5a6a" }}
      >
        <Container>
          <Navbar.Brand href="/" style={{ fontWeight: 800, color: "#fff" }}>
            zpotter gym software
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              {navLinks.map((link) => (
                <Nav.Link
                  key={link.label}
                  href={link.href}
                  eventKey={link.label}
                  style={{ color: "#fff", fontWeight: 600 }}
                >
                  {link.label}
                </Nav.Link>
              ))}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
